import React from 'react';
import './App.css';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import Header from './components/Header.js';
import Footer from './components/Footer.js';

import Inicio from './screens/Inicio';
import Nosotros from './screens/Nosotros';
import Servicios from './screens/Servicios';
import Contacto from './screens/Contacto';

function App() {
  const location = useLocation();

  const hideHeaderRoutes = [''];
  const hideFooterRoutes = [''];

  return (
    <div>
      {/* Conditionally render Header based on current route */}
      {!hideHeaderRoutes.includes(location.pathname) && <Header />}

      <main>
        <Routes>
          {/* Redirect to /Inicio when path is / */}
          <Route path="/" element={<Navigate to="/Inicio" />} />
          <Route path="/Inicio" element={<Inicio />} />
          <Route path="/Nosotros" element={<Nosotros />} />
          <Route path="/Servicios" element={<Servicios />} />
          <Route path="/Contacto" element={<Contacto />} />

          {/* 404 Route */}
          {/* You can handle this as well by using a "*" wildcard */}
          <Route path="*" element={<div>404 Not Found</div>} />
        </Routes>
      </main>

      {/* Renderizar el Footer solo si la ruta actual no está en hideFooterRoutes */}
      {!hideFooterRoutes.includes(location.pathname) && <Footer />}
    </div>
  );
}

export default App;

